import(/* webpackMode: "eager", webpackExports: ["SecureCookiesProvider"] */ "/vercel/path0/node_modules/next-client-cookies/dist/provider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"subsets\":[\"latin\"],\"variable\":\"--tp-ff-body\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/src/redux/provider.tsx");
